import * as React from "react";
import {
  Grid,
  TextField,
  MenuItem,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Box,
  Checkbox,
  FormGroup,
  Switch,
} from "@mui/material";
import { ordinalize } from "../utils/StringHelper";
import { MONTHS } from "../globals/globals";
interface Props {
  readOnly: boolean;
  handleBooleanChange: any;
  handleStringChange: any;
  handleDayChange: any;
  recurrence?: any;
}


export const TIME_UNITS = ["day", "week", "month", "year"];
// export const DAY_UNITS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28];

export const getDaysInMonth = (month = 1) => {
  const daysInMonth = {
    1: 31,  // January
    2: 29,  // February (Includes Leap Year)
    3: 31,  // March
    4: 30,  // April
    5: 31,  // May
    6: 30,  // June
    7: 31,  // July
    8: 31,  // August
    9: 30,  // September
    10: 31, // October
    11: 30, // November
    12: 31  // December
  };
  const days = daysInMonth[month];
  return Array.from({ length: days }, (_, i) => i + 1);
}

const DateBasedForm: React.FC<Props> = (props: any) => {
  React.useEffect(() => {
  }, [])
  
  return (<Grid item container xs={12} style={{ margin: "25px 0 0 10px" }}>
    <Grid
      item
      xs={12}
      className="field-container"
      style={{ paddingBottom: 20, borderBottom: "1px solid #EFE9E7" }}
    >
      <FormControl component="fieldset">
        <b style={{ marginBottom: '9px' }}>This action should start on</b>
        <div>
          <Box display="flex" alignItems="center">
            <span style={{ marginRight: "15px" }}> On </span>
            <TextField
              id="start_month"
              name="start_month"
              size="small"
              value={props.recurrence?.start_month}
              className="the-field"
              required
              select
              variant="outlined"
              onChange={props.handleStringChange}
              placeholder="1"
              style={{ minWidth: '120px', marginRight: "5px" }}
              disabled={
                props.readOnly
              }
            >
              <MenuItem value="" disabled>
                Select
              </MenuItem>
              {MONTHS.map((item) => (
                <MenuItem key={'month' + item.number} value={item.number}>
                  {item.name}
                </MenuItem>
              ))}
            </TextField>{" "}
            <TextField
              id="start_day"
              name="start_day"
              onChange={props.handleStringChange}
              size="small"
              placeholder="1"
              value={props.recurrence?.start_day}
              variant="outlined"
              select
              style={{ minWidth: '70px', marginRight: "10px" }}
              disabled={
                props.readOnly
              }
              className="the-field"
            >
              <MenuItem value="" disabled>
                Select
              </MenuItem>
              {getDaysInMonth(props.recurrence?.start_month).map((time) => (
                <MenuItem key={time} value={time}>
                  {ordinalize(time)}
                </MenuItem>
              ))}
            </TextField>{" "}
          </Box>
        </div>
      </FormControl>
    </Grid>
    <Grid
      item
      xs={12}
      className="field-container"
      style={{
        padding: "20px 0 20px 0",
        borderBottom: "1px solid #EFE9E7",
      }}
    >
      <FormControl component="fieldset">
        <b>This action should repeat</b>
        <RadioGroup
          aria-label="repeat"
          name="repeat"
          value={props.recurrence?.repeat}
          onChange={props.handleBooleanChange}
          style={{gap: '16px'}}
        >
          <FormControlLabel
            value={false}
            control={<Radio />}
            disabled={props.readOnly}
            label={
              <Box display="flex" alignItems="center">
                Does not repeat
              </Box>
            }
          />
          <FormControlLabel
            value={true}
            disabled={props.readOnly}
            control={<Radio />}
            label={
              <Box display="flex" alignItems="center">
                <span>Repeat every &nbsp; </span>
                <TextField
                  id="repeat_value"
                  name="repeat_value"
                  type="text"
                  onChange={(event) => {
                    const raw = event.target.value;
                    if (raw === "") {
                      props.handleStringChange(event);
                      return;
                    }
                    if (!/^\d+$/.test(raw)) return;
                    if (raw.length > 10) return;

                    props.handleStringChange(event);
                  }}
                  size="small"
                  value={props.recurrence?.repeat_value}
                  className="the-field"
                  required
                  variant="outlined"
                  placeholder="1"
                  style={{ width: "6em", marginRight: "5px" }}
                  disabled={props.readOnly || !props.recurrence?.repeat}
                  sx={{
                    "& input": {
                      textAlign: "center"
                    }
                  }}
                />
                <TextField
                  id="repeat_unit"
                  name="repeat_unit"
                  onChange={props.handleStringChange}
                  size="small"
                  defaultValue={"day"}
                  value={props.recurrence?.repeat_unit}
                  variant="outlined"
                  select
                  style={{ width: '110px', marginRight: "10px"}}
                  disabled={props.readOnly || !props.recurrence?.repeat}
                  className="the-field"
                >
                  <MenuItem value="" disabled>
                    Select
                  </MenuItem>
                  {TIME_UNITS.map((time) => (
                    <MenuItem key={time} value={time}>
                      {time}(s)
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            }
          />
        </RadioGroup>
        {props.recurrence?.repeat &&
          props.recurrence?.repeat_unit === "week" && (
            <FormGroup>
              <Grid container spacing={1} style={{ padding: 15 }}>
                {/* {daysOfWeek.map((day) => (
                  <Grid item xs={4} key={day}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={props.recurrence?.[day]}
                          onChange={props.handleDayChange}
                          name={day}
                          disabled={props.readOnly}
                        />
                      }
                      label={snakeCaseToTitleCase(day)}
                    />
                  </Grid>
                ))} */}
              </Grid>
            </FormGroup>
          )}
      </FormControl>
    </Grid>
    {props.recurrence?.repeat && (
      <Grid
        item
        xs={12}
        className="field-container"
        style={{
          padding: "20px 0 20px 0",
        }}
      >
        <FormControl component="fieldset">
          <b style={{ marginBottom: '9px' }}>This action should end</b>
          <RadioGroup
            aria-label="end_timing"
            name="end_timing"
            value={props.recurrence?.end_timing}
            onChange={props.handleStringChange}
            style={{gap: '16px'}}
          >
            <FormControlLabel
              value={"after_n_occurences"}
              control={<Radio />}
              disabled={props.readOnly}
              label={
                <Box display="flex" alignItems="center">
                  <span>After: &nbsp;</span>
                  <TextField
                    id="occurences"
                    name="occurences"
                    type="text" 
                    onChange={(event) => {
                      const raw = event.target.value;
                      if (raw === "") {
                        props.handleStringChange(event);
                        return;
                      }
                      if (!/^\d+$/.test(raw)) return;
                      if (raw.length > 10) return;

                      props.handleStringChange(event);
                    }}
                    size="small"
                    value={props.recurrence?.occurences}
                    className="the-field"
                    required
                    variant="outlined"
                    placeholder="1"
                    style={{ width: "5em", marginRight: "5px" }}
                    disabled={
                      props.readOnly ||
                      props.recurrence?.end_timing !== "after_n_occurences"
                    }
                    sx={{
                      "& input": {
                        textAlign: "center"
                      }
                    }}
                  />
                  <span>&nbsp; occurrences</span>
                </Box>
              }
            />
            <FormControlLabel
              value={"after_program_start_date"}
              control={<Radio />}
              disabled={props.readOnly}
              label={
                <Box display="flex" alignItems="center">
                  <span style={{ marginRight: "15px" }}> On </span>
                  <TextField
                    id="end_month"
                    name="end_month"
                    size="small"
                    value={props.recurrence?.end_month}
                    className="the-field"
                    required
                    select
                    variant="outlined"
                    onChange={props.handleStringChange}
                    placeholder="1"
                    style={{ minWidth: '120px', marginRight: "5px" }}
                    disabled={
                      props.readOnly
                    }
                  >
                    <MenuItem value="" disabled>
                      Select
                    </MenuItem>
                    {MONTHS.map((item) => (
                      <MenuItem key={'month' + item.number} value={item.number}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </TextField>{" "}
                  <TextField
                    id="end_day"
                    name="end_day"
                    onChange={props.handleStringChange}
                    size="small"
                    placeholder="1"
                    value={props.recurrence?.end_day}
                    variant="outlined"
                    select
                    style={{ minWidth: '70px', marginRight: "10px" }}
                    disabled={
                      props.readOnly
                    }
                    className="the-field"
                  >
                    <MenuItem value="" disabled>
                      Select
                    </MenuItem>
                    {getDaysInMonth(props.recurrence?.end_month).map((time) => (
                      <MenuItem key={time} value={time}>
                        {ordinalize(time)}
                      </MenuItem>
                    ))}
                  </TextField>{" "}
                </Box>
              }
            />
            <FormControlLabel
              value={"no_end_date"}
              control={<Radio />}
              disabled={props.readOnly}
              label={
                <Box display="flex" alignItems="center">
                  No End Date
                </Box>
              }
            />
          </RadioGroup>
        </FormControl>
      </Grid>
    )}
  </Grid>)
}

export default DateBasedForm